"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _luxon = require("luxon");

var _ = require(".");

var Test =
/** @class */
function () {
  function Test() {
    this.id = null;
    this.timestamp = null;
    this.animalAge = null;
    this.sampleName = null;
    this.isReductionTest = null;
    this.dewormerDate = null;
    this.dewormerClass = null;
    this.circledImagePath = null;
    this.maskedCircledImagePath = null;
    this.rawImagePath = null;
    this.processedImagePath = null;
    this.processedVideoPath = null;
    this.rawVideoPath = null;
    this.wasAudited = null;
    this.wasModified = null;
    this.notes = null;
    this.comments = null;
    this.status = null;
    this.sampleNumber = null;
    this.issueFlagged = null;
    this.createdAt = null;
    this.updatedAt = null;
    this.auditedByAdminUserId = null;
    this.practiceId = null;
    this.recipeId = null;
    this.instrumentSerialNumber = null;
    this.veterinarianId = null;
    this.userId = null;
    this.labTechId = null;
    this.animalId = null;
    this.testTypeId = null;
    this.systemInfo = null;
    this.auditedByAdminUser = null;
    this.practice = null;
    this.recipe = null;
    this.instrument = null;
    this.veterinarian = null;
    this.user = null;
    this.labTech = null;
    this.animal = null;
    this.treatments = null;
    this.testType = null;
    this.testedParasites = null;
    this.clientIp = null;
    this.pdfResultsUrl = null;
    this.testPdfs = null;
    this.completedAt = null;
    this.imageDetectionUrl = null;
    this.confidenceThresholds = null;
    this.correctionFactor = null;
    this.parentTestId = null;
    this.parentTest = null;
    this.childTests = null;
    this.jointChildTests = null;
    this.recipe2Id = null;
    this.recipe2 = null;
    this.jointParentTest = null;
    this.jointParentTestId = null;
    this.sampleQualityDescriptor = null;
    this.ellieOrderTestTypeId = null;
    this.ellieOrderTestType = null;
    this.billable = null;
    this.sourceId = null;
  }

  Test.thaw = function (testObj) {
    var _a, _b, _c, _d, _e;

    if (testObj == null) return null;
    var test = new Test();

    if (testObj.id != null) {
      test.setId(testObj.id);
    }

    if (testObj.clientIp != null) {
      test.setClientIp(testObj.clientIp);
    }

    if (testObj.timestamp != null) {
      test.setTimestamp((_a = _luxon.DateTime === null || _luxon.DateTime === void 0 ? void 0 : _luxon.DateTime.fromISO(testObj.timestamp)) !== null && _a !== void 0 ? _a : null);
    }

    if (testObj.animalAge != null) {
      test.setAnimalAge(testObj.animalAge);
    }

    if (testObj.sampleName != null) {
      test.setSampleName(testObj.sampleName);
    }

    if (testObj.isReductionTest != null) {
      test.setIsReductionTest(testObj.isReductionTest == null ? null : testObj.isReductionTest ? true : false);
    }

    if (testObj.dewormerDate != null) {
      test.setDewormerDate((_b = _luxon.DateTime === null || _luxon.DateTime === void 0 ? void 0 : _luxon.DateTime.fromISO(testObj.dewormerDate)) !== null && _b !== void 0 ? _b : null);
    }

    if (testObj.dewormerClass != null) {
      test.setDewormerClass(testObj.dewormerClass);
    }

    if (testObj.circledImagePath != null) {
      test.setCircledImagePath(testObj.circledImagePath);
    }

    if (testObj.maskedCircledImagePath != null) {
      test.setMaskedCircledImagePath(testObj.maskedCircledImagePath);
    }

    if (testObj.rawImagePath != null) {
      test.setRawImagePath(testObj.rawImagePath);
    }

    if (testObj.pdfResultsUrl != null) {
      test.setPdfResultsUrl(testObj.pdfResultsUrl);
    }

    if (testObj.processedImagePath != null) {
      test.setProcessedImagePath(testObj.processedImagePath);
    }

    if (testObj.processedVideoPath != null) {
      test.setProcessedVideoPath(testObj.processedVideoPath);
    }

    if (testObj.rawVideoPath != null) {
      test.setRawVideoPath(testObj.rawVideoPath);
    }

    if (testObj.wasAudited != null) {
      test.setWasAudited(testObj.wasAudited == null ? null : testObj.wasAudited ? true : false);
    }

    if (testObj.wasModified != null) {
      test.setWasModified(testObj.wasModified == null ? null : testObj.wasModified ? true : false);
    }

    if (testObj.notes != null) {
      test.setNotes(testObj.notes);
    }

    if (testObj.comments != null) {
      test.setComments(testObj.comments);
    }

    if (testObj.status != null) {
      test.setStatus(testObj.status);
    }

    if (testObj.sampleNumber != null) {
      test.setSampleNumber(testObj.sampleNumber);
    }

    if (testObj.issueFlagged != null) {
      test.setIssueFlagged(testObj.issueFlagged == null ? null : testObj.issueFlagged ? true : false);
    }

    if (testObj.createdAt != null) {
      test.setCreatedAt((_c = _luxon.DateTime === null || _luxon.DateTime === void 0 ? void 0 : _luxon.DateTime.fromISO(testObj.createdAt)) !== null && _c !== void 0 ? _c : null);
    }

    if (testObj.updatedAt != null) {
      test.setUpdatedAt((_d = _luxon.DateTime === null || _luxon.DateTime === void 0 ? void 0 : _luxon.DateTime.fromISO(testObj.updatedAt)) !== null && _d !== void 0 ? _d : null);
    }

    if (testObj.auditedByAdminUserId != null) {
      test.setAuditedByAdminUserId(testObj.auditedByAdminUserId);
    }

    if (testObj.practiceId != null) {
      test.setPracticeId(testObj.practiceId);
    }

    if (testObj.recipeId != null) {
      test.setRecipeId(testObj.recipeId);
    }

    if (testObj.instrumentSerialNumber != null) {
      test.setInstrumentSerialNumber(testObj.instrumentSerialNumber);
    }

    if (testObj.veterinarianId != null) {
      test.setVeterinarianId(testObj.veterinarianId);
    }

    if (testObj.userId != null) {
      test.setUserId(testObj.userId);
    }

    if (testObj.labTechId != null) {
      test.setLabTechId(testObj.labTechId);
    }

    if (testObj.animalId != null) {
      test.setAnimalId(testObj.animalId);
    }

    if (testObj.testTypeId != null) {
      test.setTestTypeId(testObj.testTypeId);
    }

    if (testObj.systemInfo != null) {
      test.setSystemInfo(testObj.systemInfo);
    }

    if (testObj.auditedByAdminUser != null) {
      test.setAuditedByAdminUser(_.AdminUser.thaw(testObj.auditedByAdminUser));
    }

    if (testObj.practice != null) {
      test.setPractice(_.Practice.thaw(testObj.practice));
    }

    if (testObj.recipe != null) {
      test.setRecipe(_.Recipe.thaw(testObj.recipe));
    }

    if (testObj.instrument != null) {
      test.setInstrument(_.Instrument.thaw(testObj.instrument));
    }

    if (testObj.veterinarian != null) {
      test.setVeterinarian(_.Veterinarian.thaw(testObj.veterinarian));
    }

    if (testObj.user != null) {
      test.setUser(_.User.thaw(testObj.user));
    }

    if (testObj.labTech != null) {
      test.setLabTech(_.LabTech.thaw(testObj.labTech));
    }

    if (testObj.animal != null) {
      test.setAnimal(_.Animal.thaw(testObj.animal));
    }

    if (testObj.treatments != null) {
      test.setTreatments(_.Treatment.thawList(testObj.treatments));
    }

    if (testObj.testType != null) {
      test.setTestType(_.TestType.thaw(testObj.testType));
    }

    if (testObj.testedParasites != null) {
      test.setTestedParasites(_.TestedParasite.thawList(testObj.testedParasites));
    }

    if (testObj.testPdfs != null) {
      test.setTestPdfs(_.TestPdf.thawList(testObj.testPdfs));
    }

    if (testObj.completedAt != null) {
      test.setTimestamp((_e = _luxon.DateTime === null || _luxon.DateTime === void 0 ? void 0 : _luxon.DateTime.fromISO(testObj.completedAt)) !== null && _e !== void 0 ? _e : null);
    }

    if (testObj.imageDetectionUrl != null) {
      test.setImageDetectionUrl(testObj.imageDetectionUrl);
    }

    if (testObj.confidenceThresholds != null) {
      test.setConfidenceThresholds(testObj.confidenceThresholds);
    }

    if (testObj.correctionFactor != null) {
      test.setCorrectionFactor(testObj.correctionFactor);
    }

    if (testObj.parentTestId != null) {
      test.setParentTestId(testObj.parentTestId);
    }

    if (testObj.parentTest != null) {
      test.setParentTest(Test.thaw(testObj.parentTest));
    }

    if (testObj.childTests != null) {
      test.setChildTests(Test.thawList(testObj.childTests));
    }

    if (testObj.jointChildTests != null) {
      test.setJointChildTests(Test.thawList(testObj.jointChildTests));
    }

    if (testObj.recipe2Id != null) {
      test.setRecipe2Id(testObj.recipe2Id);
    }

    if (testObj.recipe2 != null) {
      test.setRecipe2(_.Recipe.thaw(testObj.recipe2));
    }

    if (testObj.jointParentTest != null) {
      test.setJointParentTest(Test.thaw(testObj.jointParentTest));
    }

    if (testObj.jointParentTestId != null) {
      test.setJointParentTestId(testObj.jointParentTestId);
    }

    if (testObj.sampleQualityDescriptor != null) {
      test.setSampleQualityDescriptor(testObj.sampleQualityDescriptor);
    }

    if (testObj.ellieOrderTestTypeId != null) {
      test.setEllieOrderTestTypeId(testObj.ellieOrderTestTypeId);
    }

    if (testObj.ellieOrderTestType != null) {
      test.setEllieOrderTestType(_.EllieOrderTestType.thaw(testObj.ellieOrderTestType));
    }

    if (testObj.billable != null) {
      test.setBillable(testObj.billable == null ? null : testObj.billable ? true : false);
    }

    if (testObj.sourceId != null) {
      test.setSourceId(testObj.sourceId);
    }

    return test;
  };

  Test.thawList = function (testObjList) {
    if (testObjList == null) {
      return [];
    }

    var tests = [];

    for (var i = 0; i < testObjList.length; i++) {
      tests.push(Test.thaw(testObjList[i]));
    }

    return tests;
  };

  Test.freeze = function (test) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;

    if (test == null) {
      return null;
    }

    var testObj = {};

    if (test.getId() != null) {
      testObj.id = test.getId();
    }

    if (test.getClientIp() != null) {
      testObj.clientIp = test.getClientIp();
    }

    if (test.getTimestamp() != null) {
      testObj.timestamp = (_b = (_a = test.getTimestamp()) === null || _a === void 0 ? void 0 : _a.toISO()) !== null && _b !== void 0 ? _b : null;
    }

    if (test.getAnimalAge() != null) {
      testObj.animalAge = test.getAnimalAge();
    }

    if (test.getSampleName() != null) {
      testObj.sampleName = test.getSampleName();
    }

    if (test.getIsReductionTest() != null) {
      testObj.isReductionTest = test.getIsReductionTest() == null ? null : test.getIsReductionTest() ? 1 : 0;
    }

    if (test.getDewormerDate() != null) {
      testObj.dewormerDate = (_d = (_c = test.getDewormerDate()) === null || _c === void 0 ? void 0 : _c.toISO()) !== null && _d !== void 0 ? _d : null;
    }

    if (test.getDewormerClass() != null) {
      testObj.dewormerClass = test.getDewormerClass();
    }

    if (test.getCircledImagePath() != null) {
      testObj.circledImagePath = test.getCircledImagePath();
    }

    if (test.getMaskedCircledImagePath() != null) {
      testObj.maskedCircledImagePath = test.getMaskedCircledImagePath();
    }

    if (test.getRawImagePath() != null) {
      testObj.rawImagePath = test.getRawImagePath();
    }

    if (test.getPdfResultsUrl() != null) {
      testObj.pdfResultsUrl = test.getPdfResultsUrl();
    }

    if (test.getProcessedImagePath() != null) {
      testObj.processedImagePath = test.getProcessedImagePath();
    }

    if (test.getProcessedVideoPath() != null) {
      testObj.processedVideoPath = test.getProcessedVideoPath();
    }

    if (test.getRawVideoPath() != null) {
      testObj.rawVideoPath = test.getRawVideoPath();
    }

    if (test.getWasAudited() != null) {
      testObj.wasAudited = test.getWasAudited() == null ? null : test.getWasAudited() ? 1 : 0;
    }

    if (test.getWasModified() != null) {
      testObj.wasModified = test.getWasModified() == null ? null : test.getWasModified() ? 1 : 0;
    }

    if (test.getNotes() != null) {
      testObj.notes = test.getNotes();
    }

    if (test.getComments() != null) {
      testObj.comments = test.getComments();
    }

    if (test.getStatus() != null) {
      testObj.status = test.getStatus();
    }

    if (test.getSampleNumber() != null) {
      testObj.sampleNumber = test.getSampleNumber();
    }

    if (test.getIssueFlagged() != null) {
      testObj.issueFlagged = test.getIssueFlagged() == null ? null : test.getIssueFlagged() ? 1 : 0;
    }

    if (test.getCreatedAt() != null) {
      testObj.createdAt = (_f = (_e = test.getCreatedAt()) === null || _e === void 0 ? void 0 : _e.toISO()) !== null && _f !== void 0 ? _f : null;
    }

    if (test.getUpdatedAt() != null) {
      testObj.updatedAt = (_h = (_g = test.getUpdatedAt()) === null || _g === void 0 ? void 0 : _g.toISO()) !== null && _h !== void 0 ? _h : null;
    }

    if (test.getAuditedByAdminUserId() != null) {
      testObj.auditedByAdminUserId = test.getAuditedByAdminUserId();
    }

    if (test.getPracticeId() != null) {
      testObj.practiceId = test.getPracticeId();
    }

    if (test.getRecipeId() != null) {
      testObj.recipeId = test.getRecipeId();
    }

    if (test.getInstrumentSerialNumber() != null) {
      testObj.instrumentSerialNumber = test.getInstrumentSerialNumber();
    }

    if (test.getVeterinarianId() != null) {
      testObj.veterinarianId = test.getVeterinarianId();
    }

    if (test.getUserId() != null) {
      testObj.userId = test.getUserId();
    }

    if (test.getLabTechId() != null) {
      testObj.labTechId = test.getLabTechId();
    }

    if (test.getAnimalId() != null) {
      testObj.animalId = test.getAnimalId();
    }

    if (test.getTestTypeId() != null) {
      testObj.testTypeId = test.getTestTypeId();
    }

    if (test.getSystemInfo() != null) {
      testObj.systemInfo = test.getSystemInfo();
    }

    if (test.getAuditedByAdminUser() != null) {
      testObj.auditedByAdminUser = _.AdminUser.freeze(test.getAuditedByAdminUser());
    }

    if (test.getPractice() != null) {
      testObj.practice = _.Practice.freeze(test.getPractice());
    }

    if (test.getRecipe() != null) {
      testObj.recipe = _.Recipe.freeze(test.getRecipe());
    }

    if (test.getInstrument() != null) {
      testObj.instrument = _.Instrument.freeze(test.getInstrument());
    }

    if (test.getVeterinarian() != null) {
      testObj.veterinarian = _.Veterinarian.freeze(test.getVeterinarian());
    }

    if (test.getUser() != null) {
      testObj.user = _.User.freeze(test.getUser());
    }

    if (test.getLabTech() != null) {
      testObj.labTech = _.LabTech.freeze(test.getLabTech());
    }

    if (test.getAnimal() != null) {
      testObj.animal = _.Animal.freeze(test.getAnimal());
    }

    if (test.getTreatments() != null) {
      testObj.treatments = _.Treatment.freezeList(test.getTreatments());
    }

    if (test.getTestType() != null) {
      testObj.testType = _.TestType.freeze(test.getTestType());
    }

    if (test.getTestedParasites() != null) {
      testObj.testedParasites = _.TestedParasite.freezeList(test.getTestedParasites());
    }

    if (test.getTestPdfs() != null) {
      testObj.testPdfs = _.TestPdf.freezeList(test.getTestPdfs());
    }

    if (test.getTimestamp() != null) {
      testObj.completedAt = (_k = (_j = test.getTimestamp()) === null || _j === void 0 ? void 0 : _j.toISO()) !== null && _k !== void 0 ? _k : null;
    }

    if (test.getImageDetectionUrl() != null) {
      testObj.imageDetectionUrl = test.getImageDetectionUrl();
    }

    if (test.getConfidenceThresholds() != null) {
      testObj.confidenceThresholds = test.getConfidenceThresholds();
    }

    if (test.getCorrectionFactor() != null) {
      testObj.correctionFactor = test.getCorrectionFactor();
    }

    if (test.getParentTestId() != null) {
      testObj.parentTestId = test.getParentTestId();
    }

    if (test.getParentTest() != null) {
      testObj.parentTest = Test.freeze(test.getParentTest());
    }

    if (test.getChildTests() != null) {
      testObj.childTests = Test.freezeList(test.getChildTests());
    }

    if (test.getJointChildTests() != null) {
      testObj.jointChildTests = Test.freezeList(test.getJointChildTests());
    }

    if (test.getRecipe2Id() != null) {
      testObj.recipe2Id = test.getRecipe2Id();
    }

    if (test.getRecipe2() != null) {
      testObj.recipe2 = _.Recipe.freeze(test.getRecipe2());
    }

    if (test.getJointParentTest() != null) {
      testObj.jointParentTest = Test.freeze(test.getJointParentTest());
    }

    if (test.getJointParentTestId() != null) {
      testObj.jointParentTestId = test.getJointParentTestId();
    }

    if (test.getSampleQualityDescriptor() != null) {
      testObj.sampleQualityDescriptor = test.getSampleQualityDescriptor();
    }

    if (test.getEllieOrderTestTypeId() != null) {
      testObj.ellieOrderTestTypeId = test.getEllieOrderTestTypeId();
    }

    if (test.getEllieOrderTestType() != null) {
      testObj.ellieOrderTestType = _.EllieOrderTestType.freeze(test.getEllieOrderTestType());
    }

    if (test.getBillable() != null) {
      testObj.billable = test.getBillable() == null ? null : test.getBillable() ? 1 : 0;
    }

    if (test.getSourceId() != null) {
      testObj.sourceId = test.getSourceId();
    }

    return testObj;
  };

  Test.freezeList = function (tests) {
    if (tests == null) {
      return [];
    }

    var testObjList = [];

    for (var i = 0; i < tests.length; i++) {
      testObjList.push(Test.freeze(tests[i]));
    }

    return testObjList;
  };
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  Test.prototype.setId = function (id) {
    this.id = id;
  };

  Test.prototype.setClientIp = function (clientIp) {
    this.clientIp = clientIp;
  };

  Test.prototype.setTimestamp = function (timestamp) {
    this.timestamp = timestamp;
  };

  Test.prototype.setAnimalAge = function (animalAge) {
    this.animalAge = animalAge;
  };

  Test.prototype.setSampleName = function (sampleName) {
    this.sampleName = sampleName;
  };

  Test.prototype.setIsReductionTest = function (isReductionTest) {
    this.isReductionTest = isReductionTest;
  };

  Test.prototype.setDewormerDate = function (dewormerDate) {
    this.dewormerDate = dewormerDate;
  };

  Test.prototype.setDewormerClass = function (dewormerClass) {
    this.dewormerClass = dewormerClass;
  };

  Test.prototype.setCircledImagePath = function (circledImagePath) {
    this.circledImagePath = circledImagePath;
  };

  Test.prototype.setMaskedCircledImagePath = function (maskedCircledImagePath) {
    this.maskedCircledImagePath = maskedCircledImagePath;
  };

  Test.prototype.setPdfResultsUrl = function (pdfResultsUrl) {
    this.pdfResultsUrl = pdfResultsUrl;
  };

  Test.prototype.setRawImagePath = function (rawImagePath) {
    this.rawImagePath = rawImagePath;
  };

  Test.prototype.setProcessedImagePath = function (processedImagePath) {
    this.processedImagePath = processedImagePath;
  };

  Test.prototype.setProcessedVideoPath = function (processedVideoPath) {
    this.processedVideoPath = processedVideoPath;
  };

  Test.prototype.setRawVideoPath = function (rawVideoPath) {
    this.rawVideoPath = rawVideoPath;
  };

  Test.prototype.setWasAudited = function (wasAudited) {
    this.wasAudited = wasAudited;
  };

  Test.prototype.setWasModified = function (wasModified) {
    this.wasModified = wasModified;
  };

  Test.prototype.setNotes = function (notes) {
    this.notes = notes;
  };

  Test.prototype.setComments = function (comments) {
    this.comments = comments;
  };

  Test.prototype.setStatus = function (status) {
    this.status = status;
  };

  Test.prototype.setSampleNumber = function (sampleNumber) {
    this.sampleNumber = sampleNumber;
  };

  Test.prototype.setIssueFlagged = function (issueFlagged) {
    this.issueFlagged = issueFlagged;
  };

  Test.prototype.setCreatedAt = function (createdAt) {
    this.createdAt = createdAt;
  };

  Test.prototype.setUpdatedAt = function (updatedAt) {
    this.updatedAt = updatedAt;
  };

  Test.prototype.setAuditedByAdminUserId = function (auditedByAdminUserId) {
    this.auditedByAdminUserId = auditedByAdminUserId;
  };

  Test.prototype.setPracticeId = function (practiceId) {
    this.practiceId = practiceId;
  };

  Test.prototype.setRecipeId = function (recipeId) {
    this.recipeId = recipeId;
  };

  Test.prototype.setInstrumentSerialNumber = function (instrumentSerialNumber) {
    this.instrumentSerialNumber = instrumentSerialNumber;
  };

  Test.prototype.setVeterinarianId = function (veterinarianId) {
    this.veterinarianId = veterinarianId;
  };

  Test.prototype.setUserId = function (userId) {
    this.userId = userId;
  };

  Test.prototype.setLabTechId = function (labTechId) {
    this.labTechId = labTechId;
  };

  Test.prototype.setAnimalId = function (animalId) {
    this.animalId = animalId;
  };

  Test.prototype.setTestTypeId = function (testTypeId) {
    this.testTypeId = testTypeId;
  };

  Test.prototype.setSystemInfo = function (systemInfo) {
    this.systemInfo = systemInfo;
  };

  Test.prototype.setAuditedByAdminUser = function (auditedByAdminUser) {
    this.auditedByAdminUser = auditedByAdminUser;
  };

  Test.prototype.setPractice = function (practice) {
    this.practice = practice;
  };

  Test.prototype.setRecipe = function (recipe) {
    this.recipe = recipe;
  };

  Test.prototype.setInstrument = function (instrument) {
    this.instrument = instrument;
  };

  Test.prototype.setVeterinarian = function (veterinarian) {
    this.veterinarian = veterinarian;
  };

  Test.prototype.setUser = function (user) {
    this.user = user;
  };

  Test.prototype.setLabTech = function (labTech) {
    this.labTech = labTech;
  };

  Test.prototype.setAnimal = function (animal) {
    this.animal = animal;
  };

  Test.prototype.setTreatments = function (treatments) {
    this.treatments = treatments;
  };

  Test.prototype.setTestType = function (testType) {
    this.testType = testType;
  };

  Test.prototype.setTestedParasites = function (testedParasites) {
    this.testedParasites = testedParasites;
  };

  Test.prototype.setTestPdfs = function (testPdfs) {
    this.testPdfs = testPdfs;
  };

  Test.prototype.setCompletedAt = function (completedAt) {
    this.completedAt = completedAt;
  };

  Test.prototype.setImageDetectionUrl = function (imageDetectionUrl) {
    this.imageDetectionUrl = imageDetectionUrl;
  };

  Test.prototype.setConfidenceThresholds = function (confidenceThresholds) {
    this.confidenceThresholds = confidenceThresholds;
  };

  Test.prototype.setCorrectionFactor = function (correctionFactor) {
    this.correctionFactor = correctionFactor;
  };

  Test.prototype.setParentTestId = function (parentTestId) {
    this.parentTestId = parentTestId;
  };

  Test.prototype.setParentTest = function (parentTest) {
    this.parentTest = parentTest;
  };

  Test.prototype.setChildTests = function (childTests) {
    this.childTests = childTests;
  };

  Test.prototype.setJointChildTests = function (jointChildTests) {
    this.jointChildTests = jointChildTests;
  };

  Test.prototype.setRecipe2Id = function (recipe2Id) {
    this.recipe2Id = recipe2Id;
  };

  Test.prototype.setRecipe2 = function (recipe2) {
    this.recipe2 = recipe2;
  };

  Test.prototype.setJointParentTest = function (jointParentTest) {
    this.jointParentTest = jointParentTest;
  };

  Test.prototype.setJointParentTestId = function (jointParentTestId) {
    this.jointParentTestId = jointParentTestId;
  };

  Test.prototype.setSampleQualityDescriptor = function (sampleQualityDescriptor) {
    this.sampleQualityDescriptor = sampleQualityDescriptor;
  };

  Test.prototype.setEllieOrderTestTypeId = function (ellieOrderTestTypeId) {
    this.ellieOrderTestTypeId = ellieOrderTestTypeId;
  };

  Test.prototype.setEllieOrderTestType = function (ellieOrderTestType) {
    this.ellieOrderTestType = ellieOrderTestType;
  };

  Test.prototype.setBillable = function (billable) {
    this.billable = billable;
  };

  Test.prototype.setSourceId = function (sourceId) {
    this.sourceId = sourceId;
  };
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  Test.prototype.getId = function () {
    return this.id;
  };

  Test.prototype.getClientIp = function () {
    return this.clientIp;
  };

  Test.prototype.getTimestamp = function () {
    return this.timestamp;
  };

  Test.prototype.getAnimalAge = function () {
    return this.animalAge;
  };

  Test.prototype.getSampleName = function () {
    return this.sampleName;
  };

  Test.prototype.getIsReductionTest = function () {
    return this.isReductionTest;
  };

  Test.prototype.getDewormerDate = function () {
    return this.dewormerDate;
  };

  Test.prototype.getDewormerClass = function () {
    return this.dewormerClass;
  };

  Test.prototype.getCircledImagePath = function () {
    return this.circledImagePath;
  };

  Test.prototype.getMaskedCircledImagePath = function () {
    return this.maskedCircledImagePath;
  };

  Test.prototype.getRawImagePath = function () {
    return this.rawImagePath;
  };

  Test.prototype.getProcessedImagePath = function () {
    return this.processedImagePath;
  };

  Test.prototype.getProcessedVideoPath = function () {
    return this.processedVideoPath;
  };

  Test.prototype.getRawVideoPath = function () {
    return this.rawVideoPath;
  };

  Test.prototype.getWasAudited = function () {
    return this.wasAudited;
  };

  Test.prototype.getWasModified = function () {
    return this.wasModified;
  };

  Test.prototype.getNotes = function () {
    return this.notes;
  };

  Test.prototype.getComments = function () {
    return this.comments;
  };

  Test.prototype.getStatus = function () {
    return this.status;
  };

  Test.prototype.getSampleNumber = function () {
    return this.sampleNumber;
  };

  Test.prototype.getIssueFlagged = function () {
    return this.issueFlagged;
  };

  Test.prototype.getCreatedAt = function () {
    return this.createdAt;
  };

  Test.prototype.getUpdatedAt = function () {
    return this.updatedAt;
  };

  Test.prototype.getAuditedByAdminUserId = function () {
    return this.auditedByAdminUserId;
  };

  Test.prototype.getPracticeId = function () {
    return this.practiceId;
  };

  Test.prototype.getRecipeId = function () {
    return this.recipeId;
  };

  Test.prototype.getInstrumentSerialNumber = function () {
    return this.instrumentSerialNumber;
  };

  Test.prototype.getVeterinarianId = function () {
    return this.veterinarianId;
  };

  Test.prototype.getUserId = function () {
    return this.userId;
  };

  Test.prototype.getLabTechId = function () {
    return this.labTechId;
  };

  Test.prototype.getAnimalId = function () {
    return this.animalId;
  };

  Test.prototype.getTestTypeId = function () {
    return this.testTypeId;
  };

  Test.prototype.getSystemInfo = function () {
    return this.systemInfo;
  };

  Test.prototype.getAuditedByAdminUser = function () {
    return this.auditedByAdminUser;
  };

  Test.prototype.getPractice = function () {
    return this.practice;
  };

  Test.prototype.getRecipe = function () {
    return this.recipe;
  };

  Test.prototype.getInstrument = function () {
    return this.instrument;
  };

  Test.prototype.getVeterinarian = function () {
    return this.veterinarian;
  };

  Test.prototype.getUser = function () {
    return this.user;
  };

  Test.prototype.getLabTech = function () {
    return this.labTech;
  };

  Test.prototype.getAnimal = function () {
    return this.animal;
  };

  Test.prototype.getTreatments = function () {
    return this.treatments;
  };

  Test.prototype.getTestType = function () {
    return this.testType;
  };

  Test.prototype.getTestedParasites = function () {
    return this.testedParasites;
  };

  Test.prototype.getPdfResultsUrl = function () {
    return this.pdfResultsUrl;
  };

  Test.prototype.getTestPdfs = function () {
    return this.testPdfs;
  };

  Test.prototype.getCompletedAt = function () {
    return this.completedAt;
  };

  Test.prototype.getImageDetectionUrl = function () {
    return this.imageDetectionUrl;
  };

  Test.prototype.getConfidenceThresholds = function () {
    return this.confidenceThresholds;
  };

  Test.prototype.getCorrectionFactor = function () {
    return this.correctionFactor;
  };

  Test.prototype.getParentTestId = function () {
    return this.parentTestId;
  };

  Test.prototype.getParentTest = function () {
    return this.parentTest;
  };

  Test.prototype.getChildTests = function () {
    return this.childTests;
  };

  Test.prototype.getJointChildTests = function () {
    return this.jointChildTests;
  };

  Test.prototype.getRecipe2Id = function () {
    return this.recipe2Id;
  };

  Test.prototype.getRecipe2 = function () {
    return this.recipe2;
  };

  Test.prototype.getJointParentTest = function () {
    return this.jointParentTest;
  };

  Test.prototype.getJointParentTestId = function () {
    return this.jointParentTestId;
  };

  Test.prototype.getSampleQualityDescriptor = function () {
    return this.sampleQualityDescriptor;
  };

  Test.prototype.getEllieOrderTestTypeId = function () {
    return this.ellieOrderTestTypeId;
  };

  Test.prototype.getEllieOrderTestType = function () {
    return this.ellieOrderTestType;
  };

  Test.prototype.getBillable = function () {
    return this.billable;
  };

  Test.prototype.getSourceId = function () {
    return this.sourceId;
  };

  return Test;
}();

var _default = Test;
exports.default = _default;